<template>
  <div class="school-manager-manage">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>学校管理员管理</span>
        <div class="header-buttons">
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">添加</el-button>
          <el-button type="success" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        </div>
      </div>

      <!-- 学校管理员列表 -->
      <el-table :data="managerList" style="width: 100%;" v-loading="tableLoading">
        <el-table-column prop="username" label="账号" min-width="120"/>
        <el-table-column prop="name" label="姓名" min-width="120"/>
        <el-table-column prop="phone" label="手机号" min-width="120"/>
        <el-table-column prop="school_name" label="所属学校" min-width="150"/>
        <el-table-column prop="created_at" label="创建时间" min-width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120"/>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteManager(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加学校管理员弹窗 -->
    <el-dialog title="添加学校管理员" :visible.sync="addDialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="managerForm" label-width="100px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="所属学校" prop="school_id">
          <el-select v-model="form.school_id" placeholder="请选择学校" style="width: 100%">
            <el-option
                v-for="school in schoolList"
                :key="school.id"
                :label="school.name"
                :value="school.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addManager" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SchoolManagerManage',
  data() {
    return {
      loading: false,
      tableLoading: false,
      addDialogVisible: false,
      form: {
        username: '',
        name: '',
        phone: '',
        password: '',
        school_id: '',
        remark: ''
      },
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
        ],
        school_id: [
          {required: true, message: '请选择学校', trigger: 'change'}
        ]
      },
      managerList: [],
      schoolList: []
    }
  },
  created() {
    this.getManagerList()
    this.getSchoolList()
  },
  methods: {
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    // 显示添加弹窗
    showAddDialog() {
      this.addDialogVisible = true
    },
    // 刷新列表
    refreshList() {
      this.getManagerList()
    },
    // 添加学校管理员
    addManager() {
      this.$refs.managerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const {data: res} = await this.$http.post('/api/school_manager/add', this.form)
            if (res.status !== 0) return this.$message.error(res.message || '添加失败')
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.resetForm()
            this.getManagerList()
          } catch (error) {
            this.$message.error('添加失败')
          } finally {
            this.loading = false
          }
        }
      })
    },
    // 获取学校管理员列表
    async getManagerList() {
      this.tableLoading = true
      try {
        const {data: res} = await this.$http.get('/api/school_manager/list')
        if (res.status !== 0) return this.$message.error('获取学校管理员列表失败')
        this.managerList = res.data
      } catch (error) {
        this.$message.error('获取学校管理员列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    // 获取学校列表
    async getSchoolList() {
      try {
        const {data: res} = await this.$http.get('/api/school/list')
        if (res.status !== 0) return this.$message.error('获取学校列表失败')
        this.schoolList = res.data
      } catch (error) {
        this.$message.error('获取学校列表失败')
      }
    },
    // 删除学校管理员
    deleteManager(id) {
      this.$confirm('此操作将永久删除该学校管理员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const {data: res} = await this.$http.delete(`/api/school_manager/delete/${id}`)
          if (res.status !== 0) return this.$message.error('删除失败')
          this.$message.success('删除成功')
          this.getManagerList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 重置表单
    resetForm() {
      this.$refs.managerForm.resetFields()
    },
    // 跳转到巡检记录页面，按school_id筛选
    viewManagerRecords(schoolId) {
      this.$router.push({
        path: '/inspectionmanage',
        query: {school_id: schoolId}
      })
      this.$nextTick(() => {
        window.sessionStorage.setItem('activePath', '/inspectionmanage')
      })
    }
  }
}
</script>

<style scoped>
.school-manager-manage {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.header-buttons {
  float: right;
}

.header-buttons .el-button {
  margin-left: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style> 